/*
import  from "./test1";  //引入单个函数方法
import test2 from "./test2";   //引入单个函数方法
import * as test3 from "./test3";  //引入多个函数方法
import classtest from "./classtest";   //引入class类
*/
// import makerjs from "makerjs";
import RectangleMark from "./RectangleMark.js";                                   //00.1、外框矩形标记


import Rectangle from "./Rectangle.js";                                   //0.1、外框矩形
import IsoscelesTrapezoid from "./IsoscelesTrapezoid.js";                 //0.2、外框等腰梯形
import RightAngledTrapezoid from "./RightAngledTrapezoid.js";             //0.3、外框直角梯形
import OtherTrapezoidsA from "./OtherTrapezoidsA.js";                     //0.4、外框梯形A
import OtherTrapezoidsB from "./OtherTrapezoidsB.js";                     //0.5、外框梯形B
import ParallelogramA from "./ParallelogramA.js";                         //0.6、外框平形四边形
import ParallelogramB from "./ParallelogramB.js";                         //0.7、外框平形四边形
import SingleHole from "./SingleHole.js";                     //1、单孔
import HangWheelHoleTwo from "./HangWheelHoleTwo.js";         //2、吊轮孔2
import HangWheelHoleThree from "./HangWheelHoleThree.js";     //3、吊轮孔3
import HangWheelHoleTwoCol from "./HangWheelHoleTwoCol.js";   //4、双吊轮孔列
import HangWheelHoleTwoRow from "./HangWheelHoleTwoRow.js";   //5、双吊轮孔排
import HangHole from "./HangHole.js";                         //6、晾物孔
import HandleHoleTShaped from "./HandleHoleTShaped.js";       //7、拉手孔T字
import DoubleFixHoles from "./DoubleFixHoles.js";             //8、双固定孔
import DoubleFixHolesCol from "./DoubleFixHolesCol.js";       //8、双固定孔列
import RelSuWheelHole from "./RelSuWheelHole.js";             //9、相对吊轮孔
import HandleHole from "./HandleHole.js";                     //10、拉手孔
import RotatLockHole from "./RotatLockHole.js";               //11、旋转锁孔
import HandleHole3 from "./HandleHole3.js";                   //12、拉手孔3 
import HangWheelHoleCol from "./HangWheelHoleCol.js";         //13、吊轮孔列 
import Shaped7HandleHole from "./Shaped7HandleHole.js";       //14、7字拉手孔 
import KeyHole from "./KeyHole.js";                           //15、锁孔  
import ThreeHoles from "./ThreeHoles.js";                     //16、三孔  
import ThreeHoles2 from "./ThreeHoles2.js";                   //17、三孔2  
import ThreeHoles3 from "./ThreeHoles3.js";                   //18、三孔3  
import ThreeHoles4 from "./ThreeHoles4.js";                   //19、三孔4  
import ButterflyGap from "./ButterflyGap.js";                 //缺1、蝴蝶  
import ButterflyGap2 from "./ButterflyGap2.js";               //缺1.2、蝴蝶  
import ButterflyGap3 from "./ButterflyGap3.js";               //缺1.3、蝴蝶   
import ButterflyGap4 from "./ButterflyGap4.js";               //缺1.4、蝴蝶  
import ButterflyGapH from "./ButterflyGapH.js";                 //缺1、蝴蝶 H 
import ButterflyGap2H from "./ButterflyGap2H.js";               //缺1.2、蝴蝶H  
import ButterflyGap3H from "./ButterflyGap3H.js";               //缺1.3、蝴蝶 H  
import ButterflyGap4H from "./ButterflyGap4H.js";               //缺1.4、蝴蝶H  
import UShapeGap from "./UShapeGap.js";                       //缺2、U型   
import UShapeGapH from "./UShapeGapH.js";                       //缺2、U型 横向 
import StressHoleGap from "./StressHoleGap.js";               //缺3、应力孔  
import RunwayGap from "./RunwayGap.js";                       //缺4、跑道缺  
import SquareGap from "./SquareGap.js";                       //缺5、方缺  
import StressHoleGapH from "./StressHoleGapH.js";               //缺3、应力孔 H 
import RunwayGapH from "./RunwayGapH.js";                       //缺4、跑道缺H  
import SquareGapH from "./SquareGapH.js";                       //缺5、方缺 H 
import RectAngleGap from "./RectAngleGap.js";                 //缺5、5 矩形缺 
import RectRoundGapA from "./RectRoundGapA.js";                 //缺5、6 矩形圆角缺A 
import RectRoundGapB from "./RectRoundGapB.js";                 //缺5、6 矩形圆角缺B  
import CopperClipGap from "./CopperClipGap.js";               //缺6、铜夹  
import LongClipGap from "./LongClipGap.js";                   //缺7、长条夹   
import CopperClipGapH from "./CopperClipGapH.js";               //缺6、铜夹 H 
import LongClipGapH from "./LongClipGapH.js";                   //缺7、长条夹 H 
import EllipseGap from "./EllipseGap.js";                     //缺8、椭圆    
import HangClipGap from "./HangClipGap.js";                     //缺9、吊夹   
import HangClipGapH from "./HangClipGapH.js";                     //缺9、吊夹H   
import ObliqueAngle from "./ObliqueAngle.js";                 //角1、斜角    
import ObliqueAngleMD from "./ObliqueAngleMM.js";             //角1、斜角   
import Fillet from "./Fillet.js";                             //角2、圆角  
import Corner from "./Corner.js";                             //角3、方角     
import Fillet2 from "./Fillet2.js";                           //角4、圆角2   
import FloorSpring from "./FloorSpring.js";                   //角5、地弹簧   
import FloorSpring2 from "./FloorSpring2.js";                 //角6、地弹簧2  
import FloorSpringH from "./FloorSpringH.js";                   //角5、地弹簧 H  
import FloorSpring2H from "./FloorSpring2H.js";                 //角6、地弹簧2 H 
import FloorSpring3 from "./FloorSpring3.js";                 //角7、地弹簧3  
import FloorSpring3H from "./FloorSpring3H.js";                 //角8、地弹簧3H  
import StairCase from "./StairCase.js";                      //异形1、梯形

  ///////////////////////////////////////////////异形库相关函数//////////////////
import A01 from "./drawAbnormalShapeA01.js";                      //异形基本图形1
import A02 from "./drawAbnormalShapeA02.js";                      //异形基本图形2
import A03 from "./drawAbnormalShapeA03.js";                      //异形基本图形3
import A04 from "./drawAbnormalShapeA04.js";                      //异形基本图形3
import A05 from "./drawAbnormalShapeA05.js";                      //异形基本图形3
import A06 from "./drawAbnormalShapeA06.js";                      //异形基本图形3
import A07 from "./drawAbnormalShapeA07.js";                      //异形基本图形3
import A08 from "./drawAbnormalShapeA08.js";                      //异形基本图形3
import A09 from "./drawAbnormalShapeA09.js";                      //异形基本图形3
import A10 from "./drawAbnormalShapeA10.js";                      //异形基本图形
import A11 from "./drawAbnormalShapeA11.js";                      //异形基本图形
import A12 from "./drawAbnormalShapeA12.js";                      //异形基本图形
import A13 from "./drawAbnormalShapeA13.js";                      //异形基本图形
import A14 from "./drawAbnormalShapeA14.js";                      //异形基本图形
import A15 from "./drawAbnormalShapeA15.js";                      //异形基本图形
import A16 from "./drawAbnormalShapeA16.js";                      //异形基本图形
import A17 from "./drawAbnormalShapeA17.js";                      //异形基本图形
import A18 from "./drawAbnormalShapeA18.js";                      //异形基本图形
import A19 from "./drawAbnormalShapeA19.js";                      //异形基本图形
import A20 from "./drawAbnormalShapeA20.js";                      //异形基本图形
import A21 from "./drawAbnormalShapeA21.js";                      //异形基本图形
import A22 from "./drawAbnormalShapeA22.js";                      //异形基本图形
import A23 from "./drawAbnormalShapeA23.js";                      //异形基本图形
import A24 from "./drawAbnormalShapeA24.js";                      //异形基本图形
import A25 from "./drawAbnormalShapeA25.js";                      //异形基本图形
import A26 from "./drawAbnormalShapeA26.js";                      //异形基本图形
import A27 from "./drawAbnormalShapeA27.js";                      //异形基本图形
import A28 from "./drawAbnormalShapeA28.js";                      //异形基本图形
import A29 from "./drawAbnormalShapeA29.js";                      //异形基本图形
import A30 from "./drawAbnormalShapeA30.js";                      //异形基本图形
import A31 from "./drawAbnormalShapeA31.js";                      //异形基本图形
import A32 from "./drawAbnormalShapeA32.js";                      //异形基本图形
import A33 from "./drawAbnormalShapeA33.js";                      //异形基本图形
import A34 from "./drawAbnormalShapeA34.js";                      //异形基本图形
import A35 from "./drawAbnormalShapeA35.js";                      //异形基本图形
import A36 from "./drawAbnormalShapeA36.js";                      //异形基本图形
import A37 from "./drawAbnormalShapeA37.js";                      //异形基本图形
import A38 from "./drawAbnormalShapeA38.js";                      //异形基本图形
import A39 from "./drawAbnormalShapeA39.js";                      //异形基本图形
import A40 from "./drawAbnormalShapeA40.js";                      //异形基本图形
import A41 from "./drawAbnormalShapeA41.js";                      //异形基本图形
import A42 from "./drawAbnormalShapeA42.js";                      //异形基本图形
import A43 from "./drawAbnormalShapeA43.js";                      //异形基本图形
import A44 from "./drawAbnormalShapeA44.js";                      //异形基本图形
import A45 from "./drawAbnormalShapeA45.js";                      //异形基本图形
import A46 from "./drawAbnormalShapeA46.js";                      //异形基本图形
import A47 from "./drawAbnormalShapeA47.js";                      //异形基本图形
import A48 from "./drawAbnormalShapeA48.js";                      //异形基本图形
import A49 from "./drawAbnormalShapeA49.js";                      //异形基本图形
import A50 from "./drawAbnormalShapeA50.js";                      //异形基本图形
import A51 from "./drawAbnormalShapeA51.js";                      //异形基本图形
import A52 from "./drawAbnormalShapeA52.js";                      //异形基本图形
import A53 from "./drawAbnormalShapeA53.js";                      //异形基本图形
import A54 from "./drawAbnormalShapeA54.js";                      //异形基本图形
///////////////////////////////////////////////////////////////////////////////

import B01 from "./drawAbnormalShapeB01.js";                      //异形基本图形1
import B02 from "./drawAbnormalShapeB02.js";                      //异形基本图形2
import B03 from "./drawAbnormalShapeB03.js";                      //异形基本图形3
import B04 from "./drawAbnormalShapeB04.js";                      //异形基本图形3
import B05 from "./drawAbnormalShapeB05.js";                      //异形基本图形3
import B06 from "./drawAbnormalShapeB06.js";                      //异形基本图形3
import B07 from "./drawAbnormalShapeB07.js";                      //异形基本图形3
import B08 from "./drawAbnormalShapeB08.js";                      //异形基本图形3
import B09 from "./drawAbnormalShapeB09.js";                      //异形基本图形3
import B10 from "./drawAbnormalShapeB10.js";                      //异形基本图形
import B11 from "./drawAbnormalShapeB11.js";                      //异形基本图形
import B12 from "./drawAbnormalShapeB12.js";                      //异形基本图形
import B13 from "./drawAbnormalShapeB13.js";                      //异形基本图形
import B14 from "./drawAbnormalShapeB14.js";                      //异形基本图形
import B15 from "./drawAbnormalShapeB15.js";                      //异形基本图形
import B16 from "./drawAbnormalShapeB16.js";                      //异形基本图形
import B17 from "./drawAbnormalShapeB17.js";                      //异形基本图形
import B18 from "./drawAbnormalShapeB18.js";                      //异形基本图形
import B19 from "./drawAbnormalShapeB19.js";                      //异形基本图形
import B20 from "./drawAbnormalShapeB20.js";                      //异形基本图形
import B21 from "./drawAbnormalShapeB21.js";                      //异形基本图形
import B22 from "./drawAbnormalShapeB22.js";                      //异形基本图形
import B23 from "./drawAbnormalShapeB23.js";                      //异形基本图形
import B24 from "./drawAbnormalShapeB24.js";                      //异形基本图形
import B25 from "./drawAbnormalShapeB25.js";                      //异形基本图形
import B26 from "./drawAbnormalShapeB26.js";                      //异形基本图形
import B27 from "./drawAbnormalShapeB27.js";                      //异形基本图形
import B28 from "./drawAbnormalShapeB28.js";                      //异形基本图形
import B29 from "./drawAbnormalShapeB29.js";                      //异形基本图形
import B30 from "./drawAbnormalShapeB30.js";                      //异形基本图形
import B31 from "./drawAbnormalShapeB31.js";                      //异形基本图形
import B32 from "./drawAbnormalShapeB32.js";                      //异形基本图形
import B33 from "./drawAbnormalShapeB33.js";                      //异形基本图形
import B34 from "./drawAbnormalShapeB34.js";                      //异形基本图形
import B35 from "./drawAbnormalShapeB35.js";                      //异形基本图形
import B36 from "./drawAbnormalShapeB36.js";                      //异形基本图形
import B37 from "./drawAbnormalShapeB37.js";                      //异形基本图形
import B38 from "./drawAbnormalShapeB38.js";                      //异形基本图形
import B39 from "./drawAbnormalShapeB39.js";                      //异形基本图形
import B40 from "./drawAbnormalShapeB40.js";                      //异形基本图形
import B41 from "./drawAbnormalShapeB41.js";                      //异形基本图形
import B42 from "./drawAbnormalShapeB42.js";                      //异形基本图形
import B43 from "./drawAbnormalShapeB43.js";                      //异形基本图形
import B44 from "./drawAbnormalShapeB44.js";                      //异形基本图形
import B45 from "./drawAbnormalShapeB45.js";                      //异形基本图形
import B46 from "./drawAbnormalShapeB46.js";                      //异形基本图形
import B47 from "./drawAbnormalShapeB47.js";                      //异形基本图形
import B48 from "./drawAbnormalShapeB48.js";                      //异形基本图形
import B49 from "./drawAbnormalShapeB49.js";                      //异形基本图形
import B50 from "./drawAbnormalShapeB50.js";                      //异形基本图形
import B51 from "./drawAbnormalShapeB51.js";                      //异形基本图形
import B52 from "./drawAbnormalShapeB52.js";                      //异形基本图形
import B53 from "./drawAbnormalShapeB53.js";                      //异形基本图形
import B54 from "./drawAbnormalShapeB54.js";                      //异形基本图形
import B55 from "./drawAbnormalShapeB55.js";                      //异形基本图形
import B56 from "./drawAbnormalShapeB56.js";                      //异形基本图形
import B57 from "./drawAbnormalShapeB57.js";                      //异形基本图形
import B58 from "./drawAbnormalShapeB58.js";                      //异形基本图形
import B59 from "./drawAbnormalShapeB59.js";                      //异形基本图形
import B60 from "./drawAbnormalShapeB60.js";                      //异形基本图形
import B61 from "./drawAbnormalShapeB61.js";                      //异形基本图形
import B62 from "./drawAbnormalShapeB62.js";                      //异形基本图形
import B63 from "./drawAbnormalShapeB63.js";                      //异形基本图形
import B64 from "./drawAbnormalShapeB64.js";                      //异形基本图形
import B65 from "./drawAbnormalShapeB65.js";                      //异形基本图形
import B66 from "./drawAbnormalShapeB66.js";                      //异形基本图形


import C01 from "./drawAbnormalShapeC01.js";                      //异形基本图形1
import C02 from "./drawAbnormalShapeC02.js";                      //异形基本图形2
import C03 from "./drawAbnormalShapeC03.js";                      //异形基本图形3
import C04 from "./drawAbnormalShapeC04.js";                      //异形基本图形3
import C05 from "./drawAbnormalShapeC05.js";                      //异形基本图形3
import C06 from "./drawAbnormalShapeC06.js";                      //异形基本图形3
import C07 from "./drawAbnormalShapeC07.js";                      //异形基本图形3
import C08 from "./drawAbnormalShapeC08.js";                      //异形基本图形3
import C09 from "./drawAbnormalShapeC09.js";                      //异形基本图形3
import C10 from "./drawAbnormalShapeC10.js";                      //异形基本图形
import C11 from "./drawAbnormalShapeC11.js";                      //异形基本图形
import C12 from "./drawAbnormalShapeC12.js";                      //异形基本图形
import C13 from "./drawAbnormalShapeC13.js";                      //异形基本图形
import C14 from "./drawAbnormalShapeC14.js";                      //异形基本图形
import C15 from "./drawAbnormalShapeC15.js";                      //异形基本图形
import C16 from "./drawAbnormalShapeC16.js";                      //异形基本图形
import C17 from "./drawAbnormalShapeC17.js";                      //异形基本图形
import C18 from "./drawAbnormalShapeC18.js";                      //异形基本图形
import C19 from "./drawAbnormalShapeC19.js";                      //异形基本图形
import C20 from "./drawAbnormalShapeC20.js";                      //异形基本图形
import C21 from "./drawAbnormalShapeC21.js";                      //异形基本图形
import C22 from "./drawAbnormalShapeC22.js";                      //异形基本图形
import C23 from "./drawAbnormalShapeC23.js";                      //异形基本图形
import C24 from "./drawAbnormalShapeC24.js";                      //异形基本图形
import C25 from "./drawAbnormalShapeC25.js";                      //异形基本图形
import C26 from "./drawAbnormalShapeC26.js";                      //异形基本图形
import C27 from "./drawAbnormalShapeC27.js";                      //异形基本图形
import C28 from "./drawAbnormalShapeC28.js";                      //异形基本图形
import C29 from "./drawAbnormalShapeC29.js";                      //异形基本图形
import C30 from "./drawAbnormalShapeC30.js";                      //异形基本图形
import C31 from "./drawAbnormalShapeC31.js";                      //异形基本图形
import C32 from "./drawAbnormalShapeC32.js";                      //异形基本图形
import C33 from "./drawAbnormalShapeC33.js";                      //异形基本图形
import C34 from "./drawAbnormalShapeC34.js";                      //异形基本图形
import C35 from "./drawAbnormalShapeC35.js";                      //异形基本图形
import C36 from "./drawAbnormalShapeC36.js";                      //异形基本图形
import C37 from "./drawAbnormalShapeC37.js";                      //异形基本图形
import C38 from "./drawAbnormalShapeC38.js";                      //异形基本图形
import C39 from "./drawAbnormalShapeC39.js";                      //异形基本图形
import C40 from "./drawAbnormalShapeC40.js";                      //异形基本图形
import C41 from "./drawAbnormalShapeC41.js";                      //异形基本图形
import C42 from "./drawAbnormalShapeC42.js";                      //异形基本图形
import C43 from "./drawAbnormalShapeC43.js";                      //异形基本图形
import C44 from "./drawAbnormalShapeC44.js";                      //异形基本图形

export default {
    //边框形状
    Rectangle:Rectangle,
    IsoscelesTrapezoid:IsoscelesTrapezoid,
    RightAngledTrapezoid:RightAngledTrapezoid,
    OtherTrapezoidsA:OtherTrapezoidsA,
    OtherTrapezoidsB:OtherTrapezoidsB,
    ParallelogramA:ParallelogramA,
    ParallelogramB:ParallelogramB,
    SingleHole: SingleHole,
    HangWheelHoleTwo: HangWheelHoleTwo,
    HangWheelHoleThree: HangWheelHoleThree,
    HangWheelHoleTwoCol: HangWheelHoleTwoCol,
    HangWheelHoleTwoRow: HangWheelHoleTwoRow,
    HangHole: HangHole,
    HandleHoleTShaped: HandleHoleTShaped,
    DoubleFixHoles: DoubleFixHoles,
    DoubleFixHolesCol: DoubleFixHolesCol,
    RelSuWheelHole: RelSuWheelHole,
    HandleHole: HandleHole,
    RotatLockHole: RotatLockHole,
    HandleHole3: HandleHole3,
    HangWheelHoleCol: HangWheelHoleCol,
    Shaped7HandleHole: Shaped7HandleHole,
    KeyHole:KeyHole,
    ThreeHoles:ThreeHoles,
    ThreeHoles2:ThreeHoles2,
    ThreeHoles3:ThreeHoles3,
    ThreeHoles4:ThreeHoles4,
    ButterflyGap:ButterflyGap,
    ButterflyGap2:ButterflyGap2,
    ButterflyGap3:ButterflyGap3,
    ButterflyGap4:ButterflyGap4,
    ButterflyGapH:ButterflyGapH,
    ButterflyGap2H:ButterflyGap2H,
    ButterflyGap3H:ButterflyGap3H,
    ButterflyGap4H:ButterflyGap4H,
    UShapeGap:UShapeGap,
    UShapeGapH:UShapeGapH,
    StressHoleGap:StressHoleGap,
    RunwayGap:RunwayGap,
    SquareGap:SquareGap,
    StressHoleGapH:StressHoleGapH,
    RunwayGapH:RunwayGapH,
    SquareGapH:SquareGapH,
    RectAngleGap:RectAngleGap,
    RectRoundGapA:RectRoundGapA,
    RectRoundGapB:RectRoundGapB,
    CopperClipGap:CopperClipGap,
    LongClipGap:LongClipGap,
    CopperClipGapH:CopperClipGapH,
    LongClipGapH:LongClipGapH,
    EllipseGap:EllipseGap,
    HangClipGap:HangClipGap,
    HangClipGapH:HangClipGapH,
    ObliqueAngle:ObliqueAngle,
    ObliqueAngleMD:ObliqueAngleMD,//模板
    Fillet:Fillet,
    Corner:Corner,
    Fillet2:Fillet2,
    FloorSpring:FloorSpring,
    FloorSpring2:FloorSpring2,
    FloorSpring3:FloorSpring3,
    FloorSpringH:FloorSpringH,
    FloorSpring2H:FloorSpring2H,
    FloorSpring3H:FloorSpring3H,
    //标记
    RectangleMark:RectangleMark,
    //异形
    StairCase:StairCase,
    //异形库
    A01,A02,A03,A04,A05,A06,A07,A08,A09,A10,
    A11,A12,A13,A14,A15,A16,A17,A18,A19,A20,
    A21,A22,A23,A24,A25,A26,A27,A28,A29,A30,
    A31,A32,A33,A34,A35,A36,A37,A38,A39,A40,
    A41,A42,A43,A44,A45,A46,A47,A48,A49,A50,
    A51,A52,A53,A54,
    
    B01,B02,B03,B04,B05,B06,B07,B08,B09,B10,
    B11,B12,B13,B14,B15,B16,B17,B18,B19,B20,
    B21,B22,B23,B24,B25,B26,B27,B28,B29,B30,
    B31,B32,B33,B34,B35,B36,B37,B38,B39,B40,
    B41,B42,B43,B44,B45,B46,B47,B48,B49,B50,
    B51,B52,B53,B54,B55,B56,B57,B58,B59,B60,
    B60,B61,B62,B63,B64,B65,B66,

    
    C01,C02,C03,C04,C05,C06,C07,C08,C09,C10,
    C11,C12,C13,C14,C15,C16,C17,C18,C19,C20,
    C21,C22,C23,C24,C25,C26,C27,C28,C29,C30,
    C31,C32,C33,C34,C35,C36,C37,C38,C39,C40,
    C41,C42,C43,C44,
    
};
